class ScrollImage {
  constructor($element) {
    this.$element = $element;
    this.element = $element[0];

    if (!this.element) {
      return;
    }

    this.update = this.update.bind(this);

    window.addEventListener("scroll", this.update, {
      passive: true,
    });

    window.addEventListener("resize", this.update);

    this.update();
  }

  update() {
    if (window.innerWidth < 992) {
      this.element.style.transform = "";
      return;
    }

    const rect = this.element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (rect.bottom < 0 || rect.top > viewportHeight) {
      return;
    }

    const progress =
      (viewportHeight - rect.top) / (viewportHeight + rect.height);

    const clampedProgress = Math.min(Math.max(progress, 0), 1);

    const translateY = 130 - clampedProgress * 260;

    this.element.style.transform = `translateY(${translateY}px)`;
  }
}

export default ScrollImage;
